import { ReactNode } from 'react';
import Link from '@mui/material/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  externalLinkIcon: {
    marginLeft: theme.spacing(0.25),
    verticalAlign: 'text-bottom',
    width: '1rem',
    height: '1rem',
  },
}));

type AccordionLinkProps = {
  href: string;
  children: ReactNode;
  external?: boolean;
  className?: string;
};

const AccordionLink = ({
  href,
  children,
  external,
  className,
}: AccordionLinkProps) => {
  const classes = useStyles();

  return (
    <Link
      href={href}
      target={external ? '_blank' : '_self'}
      className={className}
      rel={external ? 'noopener noreferrer' : undefined}
    >
      {children}
      {external && <OpenInNewIcon className={classes.externalLinkIcon} />}
    </Link>
  );
};

export default AccordionLink;
